var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLevelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#E1E129"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.125 24.25V26",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.958 28.834H24.2913V28.0007C24.2913 27.084 23.5413 26.334 22.6247 26.334H17.6247C16.708 26.334 15.958 27.084 15.958 28.0007V28.834V28.834Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.125 28.834H25.125",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 23.8327C16.7753 23.8327 14.167 21.2243 14.167 17.9993V15.4993C14.167 13.6577 15.6587 12.166 17.5003 12.166H22.5003C24.342 12.166 25.8337 13.6577 25.8337 15.4993V17.9993C25.8337 21.2243 23.2253 23.8327 20.0003 23.8327Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5585 20.2083C13.9335 20.0083 13.3835 19.6417 12.9502 19.2083C12.2002 18.375 11.7002 17.375 11.7002 16.2083C11.7002 15.0417 12.6169 14.125 13.7835 14.125H14.3252C14.1585 14.5083 14.0752 14.9333 14.0752 15.375V17.875C14.0752 18.7083 14.2502 19.4917 14.5585 20.2083Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4414 20.2083C26.0664 20.0083 26.6164 19.6417 27.0497 19.2083C27.7997 18.375 28.2997 17.375 28.2997 16.2083C28.2997 15.0417 27.3831 14.125 26.2164 14.125H25.6747C25.8414 14.5083 25.9247 14.9333 25.9247 15.375V17.875C25.9247 18.7083 25.7497 19.4917 25.4414 20.2083Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevelIcon);
export default __webpack_public_path__ + "static/media/levelIcon.e9ca45665fc8ae66d3b4b03d6f0bc232.svg";
export { ForwardRef as ReactComponent };